import { useSearchParams } from 'react-router-dom';
import { Footer, TitleBar } from '../../../components';
import TitleUpdater from '../../../components/common/TitleUpdater';
import { useBusinessFunctionData } from '../../../hooks/business-functions/queries';
import { useLocationName } from '../../../hooks';
import TableV3 from '../../../components/generic/Table/TableV3';
import { columns } from '../columns/columns';
import { useBusinessFunctionsItApplications } from '../hooks/useBusinessFunctionsItApplications';

export const CyberHubBusinessFunctionsItApplications = () => {
  let [searchParams] = useSearchParams();
  const businessFunctionId = searchParams.get('businessFunctionId')!;
  const locationId = searchParams.get('locationId')!;

  const { businessFunctionName } = useBusinessFunctionData(businessFunctionId);
  const { locationName } = useLocationName(locationId);

  const { data, loading } = useBusinessFunctionsItApplications(
    businessFunctionId,
    locationId,
  );

  const pageTitle = locationName
    ? `${locationName} - Business Function Applications`
    : 'Business Function Applications';

  const title = locationName
    ? `${locationName} - Business Function Applications`
    : 'Business Function Applications';

  return (
    <div>
      <TitleUpdater title={pageTitle} />
      <TitleBar title={title} subtitle={businessFunctionName} />
      <TableV3
        title="Applications"
        data={data?.itApplications}
        columns={columns}
        loading={loading}
      />
      <Footer goBack />
    </div>
  );
};
